import {BasketSessionModel} from './basket-session.model';
import {createRoomBasket, createRoomBasketSession} from '../../room/model';
import {BasketModel} from './basket.model';
import {SessionDisplay} from '../../session/model';
import {createExtraBasket, createExtraBasketSession} from '../../extra/model';

// todo refactor rooms and hotelExtra in object and not array

export const createBasketSession = (payload: any = {}): BasketSessionModel => {
  const rooms = payload.rooms && Object.keys(payload.rooms)
    ? Object.values(payload.rooms).map(value => createRoomBasketSession(value))
    : [];

  const hotelExtras = payload.hotelExtras && Object.keys(payload.hotelExtras)
    ? Object.values(payload.hotelExtras).map(value => createExtraBasketSession(value))
    : [];

  return {
    rooms,
    hotelExtras,
    referenceRateIds: payload.referenceRateIds,
    isBookingRequest: payload.isBookingRequest,
    isMixedRate: payload.isMixedRate,
    hasOfferCode: payload.hasOfferCode,
  };
};

export const createBasket = (payload: any = {}, currency?: SessionDisplay['currency']): BasketModel => {
  const rooms = payload.rooms && Object.keys(payload.rooms)
    ? Object.values(payload.rooms).map(value => createRoomBasket(value))
    : [];

  const hotelExtras = payload.hotelExtras && Object.keys(payload.hotelExtras)
    ? Object.values(payload.hotelExtras).map(value => createExtraBasket(value))
    : [];

    const basketCreated = {
      id: Date.now().toString(10),
      rooms,
      hotelExtras,
      price: payload.price,
      taxes: payload.taxes,
      isBookingRequest: payload.isBookingRequest,
      currency: currency || ''
    };
  
    return basketCreated;
};
